<template>
    <div class="box">
        <Box title="资产报废">
            <FacilityDetails :data="{
                Images: require('@/assets/img/Icon_1.png'),
                EquName: data.EquName,
                EquNo: data.EquCode,
                Size: data.EquType,
                EquNumber: data.EquNumber,
                DepartmentName: data.DepartmentName,
                deadline: data.deadline
            }"/>
            <div class="infoBox">
                <p class="title">报修信息</p>
                <Field title="科室留用" type="teb" :tabSelected='IsKeep'  :data="[{id:'Y',name:'是'},{id:'N',name:'否'}]"
                @onMessage="value=>IsKeep=value.id"/>
               <Field @manuconfirm="DepUserCode=arguments[0].a,DepUserName=arguments[0].b" :text='DepUserName' title="科室负责人" :action="true"  placeholder="请选择" type="manufacturer"  name="personnel"/>
                <!-- <div class="FieldItems">
                    <span class="title">报修人员</span>
                    <div :class="staff ? 'action' : ''" @click="$router.push('/staffSearch')">
                        {{staff ? staff.UserName : '请选择'}}
                        <img src="../../assets/img/right-min.png"/>
                    </div>
                </div> -->
               <Field @manuconfirm="DepUserCode=arguments[0].a" @onMessage="value=>cause=value" title="报废原因" :action="true" type="textarea"/>
            </div>
            <ImgModule upload :ImgMaxCount='8'  :img='uploadImg'  @afterRead="afterRead(arguments[0])" @deleteImg="deleteImg(arguments[0])" :deletable='true'/>
        </Box>
        <Footer button="申请报废" @change="change"/>
    </div>
</template>

<script>
    import Box from '../../components/commonBox/commonBox'
    import FacilityDetails from '../../components/facilityDetails/facilityDetails'
    import ImgModule from '../../components/imgModule/imgModule'
    import Footer from '../../components/footer/footer'
    import Field from '../../components/field/field'
    import Bus from "../../components/bus/bus";
    export default {
        name: 'Scrap',
        components: {
            Box,
            FacilityDetails,
            ImgModule,
            Footer,
            Field
        },
        data() {
            return {
                data: this.$route.params.item,
                IsKeep:'N',    //是否留用
                uploadImg: [],      //  图片
                cause: null,        //  报废原因
                DepUserCode:this.$route.params.item.KSFZR ,//当前设备科室负责人编号
                DepUserName:this.$route.params.item.DirectorName//当前设备 科室负责人姓名
            }
        },
        mounted(){
        },
        methods: {
            change() {
                const data={
                    Store:this.$UserInfo.StoreCode,
                    UserCode:this.$UserInfo.UserId,
                    EquId:this.data.EquCode,
                    DepartmentId:this.data.DepartmentId,
                    Reason:this.cause,
                    DepUserCode:this.DepUserCode,
                    IsKeep:this.IsKeep,
                    TPMC1:this.uploadImg.length>=1?this.uploadImg[0].content:'',
                    TPMC2:this.uploadImg.length>=2?this.uploadImg[1].content:'',
                    TPMC3:this.uploadImg.length>=3?this.uploadImg[2].content:'',
                    TPMC4:this.uploadImg.length>=4?this.uploadImg[3].content:'',
                    TPMC5:this.uploadImg.length>=5?this.uploadImg[4].content:'',
                    TPMC6:this.uploadImg.length>=6?this.uploadImg[5].content:'',
                    TPMC7:this.uploadImg.length>=7?this.uploadImg[6].content:'',
                    TPMC8:this.uploadImg.length>=8?this.uploadImg[7].content:''
                };
                if(!this.$verification(data,[{id:'DepUserCode',name:'请选择科室负责人!'},{id:'Reason',name:'报废原因不能为空!'}]))return false;
                this.$post('api/BF/BF',data).then(result=>{
                    if(result.Status){
                        this.$Toast({
                            message:'申请报废成功!',
                            duration:1500,
                            onClose:x=>{
                                this.$router.go(-1);
                            }
                        });
                    }else this.$Toast(result.Msg);
                })
            },afterRead(value){//得到图片file对象
                //判断是否对象与Array
                let that=this;
                if(value instanceof Array){
                    value.forEach(function(item,index){
                        item.DABH=that.$getRandomNumber(5);//为图片创建临时编号
                        that.uploadImg.push(item);
                    })
                }else {
                    value.DABH=that.$getRandomNumber(5);//为图片创建临时编号
                    that.uploadImg.push(value);
                }
                this.$Toast('预加载完成!');
            },deleteImg(value){//需要删除得图片对象
                this.uploadImg.splice(this.uploadImg.findIndex(x=>x.DABH===value.DABH),1);
                this.$Bus.$emit('YSRKDelete',this.uploadImg);
            }
        }
    }
</script>

<style scoped lang="scss">
    .box{
        padding-bottom: 114px;
    }
    .FieldItems {
        height: 112px;
        border-bottom: 2px solid #F3F3F3;
        display: flex;
        align-items: center;
        font-size: 29px;
        color: #858585;

        .action {
            color: $TEXT-DARK-COLOR;
        }

        .title {
            font-size: 30px;
            color: $TEXT-DARK-COLOR;
            flex: 1;
        }

        div {
            display: flex;
            align-items: center;

            img {
                width: 32px;
                height: 30px;
                margin-left: 8px;
            }
        }

        &:last-child {
            border: none
        }
    }
    .FieldItemsTitle{
        font-size: 30px;
        color: $TEXT-DARK-COLOR;
        margin: 36px 0 20px;
    }
</style>



// WEBPACK FOOTER //
// src/page/scrap/scrap.vue